var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderPreviousEditions',{attrs:{"title":"Edició 2023"}},[_c('a',{staticClass:"navbar-item",attrs:{"href":"https://hikeandfly.puntxat.cat/admin/storage/hf_bergueda_normativa_2023.pdf"}},[_vm._v("Normativa")])]),_c('Ranking',{ref:"ranking",attrs:{"showPositionVariations":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }